module.exports = __webpack_public_path__ + "static/img/eicad_function03.fb05bb78.png";